/**
 * DevExtreme (esm/__internal/core/r1/runtime/inferno/mocked/shared.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const ERROR_MSG = "a runtime error occured! Use Inferno in development environment to find the error.";
export function isNullOrUndef(o) {
  return void 0 === o || null === o;
}
export function isInvalid(o) {
  return null === o || false === o || true === o || void 0 === o;
}
export function isFunction(o) {
  return "function" === typeof o;
}
export function isNull(o) {
  return null === o;
}
export function throwError(message) {
  if (!message) {
    message = ERROR_MSG;
  }
  throw new Error(`Inferno Error: ${message}`);
}